import { Link } from "@tanstack/react-router";
import { FEATURED_WORK } from "@/lib/work";
import { ArrowRight } from "@/components/icons";
import { WorkTile } from "@/components/work/work-tile";

/**
 * Three real products: one full-width scene, two side by side. Every image is
 * a screenshot of the live product.
 */
export function SelectedWork() {
  const [lead, ...rest] = FEATURED_WORK;
  return (
    <section
      aria-labelledby="work-h"
      className="relative mx-auto max-w-[1400px] border-t border-border/60 px-6 py-20 md:px-10 md:py-32"
    >
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-[46ch]">
          <h2 id="work-h" className="fluid-h2 font-display tracking-[-0.035em]">
            Selected work
          </h2>
          <p className="mt-5 text-pretty text-lg leading-snug text-muted-foreground md:text-xl">
            Products we designed, built and run in production.
          </p>
        </div>
        <Link
          to="/work"
          className="group inline-flex min-h-11 items-center gap-2 font-display text-base underline decoration-border underline-offset-4 transition-colors hover:decoration-foreground"
        >
          All work
          <ArrowRight
            aria-hidden
            className="h-4 w-4 transition-transform duration-300 ease-out group-hover:translate-x-1"
          />
        </Link>
      </div>

      <div className="mt-12 grid gap-5 md:grid-cols-2">
        <div className="md:col-span-2">
          <WorkTile item={lead} lead index={0} />
        </div>
        {rest.slice(0, 2).map((w, i) => (
          <WorkTile key={w.slug} item={w} index={i + 1} />
        ))}
      </div>
    </section>
  );
}
